import { render, staticRenderFns } from "./ApiSmsApiaccount.vue?vue&type=template&id=12227094&scoped=true"
import script from "./ApiSmsApiaccount.vue?vue&type=script&lang=js"
export * from "./ApiSmsApiaccount.vue?vue&type=script&lang=js"
import style0 from "./ApiSmsApiaccount.vue?vue&type=style&index=0&id=12227094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12227094",
  null
  
)

export default component.exports